import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    photos: PropTypes.array.isRequired,
  },
  componentDidMount() {
    $(".circle-photo-area").vegas({
      overlayGradation: false,
      transition: "flash",
      delay: 5000,
      animation: "random",
      animationDuration: 5000,
      slides: this.props.photos,
      cover: false,
      color: "#000",
    });
    $(".vegas-timer").hide();
    $(".vegas-timer-progress").hide();
  },
  render() {
    return (
      <div
        className="circle-photo-area"
        style={{ height: "300px", maxHeight: "460px", padding: "10px" }}
      />
    );
  },
});
